import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import CalculatorSection from './components/CalculatorSection';
import ProcessSection from './components/ProcessSection';
import CTASection from './components/CTASection';

export default function DSCR() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <BenefitsSection />
        <CalculatorSection />
        <ProcessSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
